export const getFooterDateYesterday = () => {
  const updatedDate = new Date(Date.now());
  updatedDate.setDate(updatedDate.getDate() - 1);
  return 'As of ' + updatedDate.toLocaleDateString();
};
